

import React from 'react';

export default function Footer() {
    return (
        <footer className="footer-section position-relative cstm-bk zindex-f">
            <div className="footer-top ptb-120" style={{display:'none'}}>
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-md-8 col-lg-3 mb-md-4 mb-lg-0">
                            <div className="footer-single-col">
                                <div className="footer-single-col mb-2">
                                    <img src="assets/img/logo/syncloop-logo.svg" alt="logo"
                                         className="footer-logo img-fluid logo-white" />
                                </div>
                                <p className="py-4">Visual experience-based workspace where you efficiently build,
                                    integrate
                                    & deploy APIs</p>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-8 mt-4 mt-md-0 mt-lg-0">
                            <div className="row">
                                <div className="col-md-3 col-lg-3 mt-4 mt-md-0 mt-lg-0">
                                    <div className="footer-single-col">
                                        <h3>By Role</h3>
                                        <ul className="list-unstyled footer-nav-list mb-lg-0">
                                            <li><a href="/developers.html"
                                                   className="text-decoration-none">Developers</a>
                                            </li>
                                            <li><a href="/architects.html"
                                                   className="text-decoration-none">Architects</a>
                                            </li>
                                            <li><a href="/tech-leaders.html" className="text-decoration-none">Tech
                                                Leaders</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-3 col-lg-3 mt-4 mt-md-0 mt-lg-0">
                                    <div className="footer-single-col">
                                        <h3>Resources</h3>
                                        <ul className="list-unstyled footer-nav-list mb-lg-0">
                                            <li><a href="/training.html" className="text-decoration-none">Training</a>
                                            </li>
                                            <li><a href="/documentation.html"
                                                   className="text-decoration-none">Documentation</a></li>
                                            <li><a
                                                href="/blog.html?utm_source=Website&utm_medium=click&utm_id=blogs&utm_content=footer-link"
                                                className="text-decoration-none">Blogs</a></li>
                                            <li><a
                                                href="/faq.html?utm_source=Website&utm_medium=click&utm_id=faq&utm_content=footer-link"
                                                className="text-decoration-none">FAQs</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-3 col-lg-3 mt-4 mt-md-0 mt-lg-0">
                                    <div className="footer-single-col">
                                        <h3>Support</h3>
                                        <ul className="list-unstyled footer-nav-list mb-lg-0">
                                            <li><a
                                                href="/pricing.html?utm_source=Website&utm_medium=click&utm_id=pricing&utm_content=footer-link"
                                                className="text-decoration-none">Pricing</a></li>
                                            <li><a
                                                href="/community.html?utm_source=Website&utm_medium=click&utm_id=community&utm_content=footer-link"
                                                className="text-decoration-none">Community</a></li>
                                            <li><a target="_blank" href="https://discord.gg/EnazFJpGQs"
                                                   className="text-decoration-none">Join Discord</a></li>

                                            <li><a target="_blank" href="https://cloud.syncloop.com/"
                                                   className="text-decoration-none">Sign in</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-md-3 col-lg-3 mt-4 mt-md-0 mt-lg-0">
                                    <div className="footer-single-col">
                                        <h3>Company</h3>
                                        <ul className="list-unstyled footer-nav-list mb-lg-0">
                                            <li><a
                                                href="/about.html?utm_source=Website&utm_medium=click&utm_id=about-us&utm_content=footer-link"
                                                className="text-decoration-none">About us</a></li>
                                            <li><a href="/contact-us.html" className="text-decoration-none">Contact
                                                us</a>
                                            </li>
                                            <li><a href="/privacy-policy.html" className="text-decoration-none">Privacy
                                                Policy</a></li>
                                            <li><a href="/terms-conditions.html" className="text-decoration-none">Terms &
                                                Conditions</a></li>
                                            <li><a href="/web-accessibility-policy.html"
                                                   className="text-decoration-none">Web
                                                Accessibility Policy</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="footer-bottom footer-light py-4">
                <div className="container-fluid">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-md-7 col-lg-7">
                            <div className="copyright-text">
                                <p className="mb-lg-0 mb-md-0">© {new Date().getFullYear()} Syncloop - Nature9 Inc. All rights reserved.</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-4">
                            <div className="footer-single-col text-start text-lg-end text-md-end">
                                <ul className="list-unstyled list-inline footer-social-list mb-0">
                                    <li className="list-inline-item"><a target="_blank"
                                                                        href="https://discord.com/invite/EnazFJpGQs?utm_source=Website&utm_medium=click&utm_id=discord&utm_content=bottom">
                                        <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 800 800"
      version="1.1"
      viewBox="0 0 800 800"
      xmlSpace="preserve"
    >
      <path
        d="M659.9 161.6c-48.6-22.3-99.9-38.2-152.7-47.3-1-.2-2 .3-2.5 1.2-6.6 11.7-13.9 27-19 39.1-56.8-8.6-114.6-8.6-171.5 0-5.7-13.4-12.1-26.4-19.3-39.1-.5-.9-1.5-1.3-2.5-1.2-52.7 9.1-104 25-152.7 47.3-.4.2-.8.5-1 .8-97 145.3-123.7 287-110.6 426.9.1.7.4 1.3 1 1.8a621.97 621.97 0 00187.2 94.6c1 .3 2-.1 2.6-.9 14.5-19.7 27.3-40.5 38.3-62.3.6-1.2.1-2.6-1-3.2-.1 0-.2-.1-.3-.1-20.2-7.7-39.8-17.1-58.5-27.9-1.2-.7-1.5-2.1-.9-3.3.2-.3.4-.5.6-.7 3.9-3 7.8-6 11.6-9.1.7-.6 1.6-.7 2.4-.3 122.7 56 255.6 56 376.9 0 .8-.4 1.8-.3 2.4.3 3.7 3.1 7.7 6.2 11.7 9.1 1.1.8 1.3 2.3.5 3.4-.2.2-.4.4-.7.6-18.7 10.9-38.3 20.2-58.5 27.9-1.2.5-1.9 1.9-1.4 3.1 0 .1.1.2.1.2 11.2 21.8 24.1 42.6 38.3 62.3.6.8 1.7 1.2 2.6.9A620.88 620.88 0 00770.6 591c.6-.4.9-1 1-1.7 15.6-161.8-26.2-302.3-110.9-426.9 0-.3-.4-.7-.8-.8zM275.6 504.1c-37 0-67.4-33.9-67.4-75.6s29.9-75.6 67.4-75.6c37.8 0 68 34.2 67.4 75.6 0 41.7-29.8 75.6-67.4 75.6zm249.2 0c-37 0-67.4-33.9-67.4-75.6s29.8-75.6 67.4-75.6c37.8 0 68 34.2 67.4 75.6 0 41.7-29.5 75.6-67.4 75.6z"
        className="ic_color"
      ></path>
    </svg>
                                    </a></li>
                                    <li className="list-inline-item"><a target="_blank"
                                                                        href="https://www.youtube.com/@syncloop">
                                        <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 800 800"
      version="1.1"
      viewBox="0 0 800 800"
      xmlSpace="preserve"
    >
      <path
        d="M323.3 511.5v-223l196 111.5-196 111.5zm436-293.2c-8.9-32.5-33.9-57.7-65.6-66.6l-.7-.2c-79.8-10.2-172.2-16-265.9-16-9.5 0-19 .1-28.5.2h1.5c-8.1-.1-17.5-.2-27.1-.2-93.7 0-186.1 5.8-276.8 17l10.9-1.1c-32.4 9.1-57.4 34.2-66.1 66.1l-.2.7C30.7 271 25 331.7 25 393.7v6.6-.4 6.3c0 62 5.7 122.7 16.7 181.5l-1-6.1c8.9 32.5 33.9 57.7 65.6 66.6l.7.2c79.8 10.2 172.2 16 265.9 16 9.5 0 19-.1 28.5-.2h-1.5c8.1.1 17.6.2 27.1.2 93.7 0 186.1-5.8 276.8-17l-10.9 1.1c32.5-9.1 57.5-34.2 66.2-66.1l.2-.7c10-52.7 15.7-113.4 15.7-175.4v-6.6-6c0-62-5.7-122.7-16.7-181.5l1 6.1z"
        className="ic_color"
      ></path>
    </svg>
                                    </a></li>
                                    <li className="list-inline-item"><a target="_blank"
                                                                        href="https://twitter.com/Syncloop_dev">
                                        <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      x="0"
      y="0"
      viewBox="0 0 26 26"
    >
      <path
        d="M25.855 5.574c-.94.418-1.953.7-3.015.828a5.279 5.279 0 002.308-2.906 10.515 10.515 0 01-3.335 1.274 5.251 5.251 0 00-8.945 4.79 14.908 14.908 0 01-10.821-5.49 5.23 5.23 0 00-.711 2.645c0 1.82.926 3.426 2.336 4.367a5.205 5.205 0 01-2.379-.656v.066a5.255 5.255 0 004.21 5.149 5.204 5.204 0 01-1.382.183c-.34 0-.668-.031-.988-.094a5.252 5.252 0 004.902 3.645 10.508 10.508 0 01-6.52 2.246c-.425 0-.84-.023-1.25-.07a14.858 14.858 0 008.047 2.355c9.657 0 14.938-8 14.938-14.933 0-.23-.004-.457-.016-.684a10.501 10.501 0 002.621-2.715"
        className="ic_color"
      ></path>
    </svg>
                                    </a></li>
                                    <li className="list-inline-item"><a target="_blank"
                                                                        href="https://www.linkedin.com/company/syncloop/">
                                       <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 30 30">
                                            <path class="ic_color" d="M9,25H4V10h5V25z M6.501,8C5.118,8,4,6.879,4,5.499S5.12,3,6.501,3C7.879,3,9,4.121,9,5.499C9,6.879,7.879,8,6.501,8z M27,25h-4.807v-7.3c0-1.741-0.033-3.98-2.499-3.98c-2.503,0-2.888,1.896-2.888,3.854V25H12V9.989h4.614v2.051h0.065 c0.642-1.18,2.211-2.424,4.551-2.424c4.87,0,5.77,3.109,5.77,7.151C27,16.767,27,25,27,25z"></path>
                                        </svg>
                                    </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
